import React, { useEffect, useState } from "react";
import styled from "styled-components";
import logoImageWhite from "../Images/full-logo.png";
import logoPhoenix from "../Images/logo_phoenix.png";
import logoDWSD from "../Images/logo_dwsd.png";
import logoGLWA from "../Images/logo-glwa.svg";
import logoDDOT from "../Images/logo-ddot.png";
import logoGibralter from "../Images/logo-GibralterBoatYard.png";
import logoDearborn from "../Images/logo-dearbornschools.png";
import logoHenryFord from "../Images/logo-henryford.png";
import logoServicar from "../Images/logo-servicar.png";
import logoWyandotte from "../Images/logo-wyandotte.png";
import { useNavigate } from "react-router-dom";

function Footer() {
  const [currentYear, setCurrentYear] = useState();

  const history = useNavigate();
  const onClickContactUs = () => {
    history("/contactus");
  };

  useEffect(() => {
    const date = new Date().getFullYear();
    setCurrentYear(date);
  }, []);

  const onClickAboutUs = () => {
    history("/aboutus");
  };

  const onClickPrivacy = () => {
    history("/privacy");
  };
  // here should be changed
  const onClickLaraLogin = () => {
    history("/laracheckstatus");
  };

  return (
    <Container>
      <ImportantCompanies>
        <Slogan>Companies that trust SafeT1st:</Slogan>
        <CompanyLogoContainer>
          <CompanyLogo src={logoDWSD} style={{height: "60px"}}/>
          {/* <CompanyLogo src={logoGLWA} /> */}
          <CompanyLogo src={logoPhoenix} style={{height: "60px"}}/>
          <CompanyLogo src={logoDDOT} />
          <CompanyLogo src={logoGibralter} />
          <CompanyLogo src={logoDearborn}  />
          <CompanyLogo src={logoHenryFord} />
          <CompanyLogo src={logoServicar} />
          <CompanyLogo src={logoWyandotte} />
        </CompanyLogoContainer>
      </ImportantCompanies>
      <FooterContainer>
        <MainFooterContainer>
          <FooterLinksContainer>
            <PrivacyPolicy onClick={() => onClickPrivacy()}>
              Privacy Policy
            </PrivacyPolicy>
            <AboutUs onClick={() => onClickAboutUs()}>About Us</AboutUs>
            <ContactUs onClick={() => onClickContactUs()}>Contact Us</ContactUs>
            {/* {!user && !larauser ? ( */}
            <LaraLogin onClick={() => onClickLaraLogin()}>
              Certificate Verification
            </LaraLogin>
            {/* ) : ( */}
            {/* <div></div>
            )} */}
          </FooterLinksContainer>
        </MainFooterContainer>
        <LogoCopyRight>
          <Logo src={logoImageWhite} />
          <FooterAddressContainer>
            <Address>
              <CopyRight>&copy; {currentYear} eSpec Software</CopyRight>
              <p><strong>1-800-274-4437</strong></p>
              <p>12815 Premier Center Court</p>
              <p>Plymouth, MI 48170</p>
            </Address>
          </FooterAddressContainer>
        </LogoCopyRight>
      </FooterContainer>
    </Container>
  );
}

export default Footer;

const Container = styled.div`
  display: grid;
  grid-template-rows: 70px 260px;
  background: white;
`;
const ImportantCompanies = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.1);
  font-size: 1rem;

`;
const Slogan = styled.div`
  font-weight: 600;
  font-size: 18px;
  text-align: center;

  @media (max-width: 425px) {
    font-size: 14px;
  }
`;
const FooterContainer = styled.div`
  padding: 20px 20px 250px 20px;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const PrivacyPolicy = styled.div`
  padding-top: 10px;
  width: fit-content;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
const AboutUs = styled.div`
  padding-top: 10px;
  width: fit-content;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
const ContactUs = styled.div`
  padding-top: 10px;
  /* padding-bottom: 30px; */
  width: fit-content;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const LaraLogin = styled.div`
  padding-top: 10px;
  padding-bottom: 30px;
  width: fit-content;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
const LogoCopyRight = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.img`
  height: 50px;
  @media (max-width: 380px) {
    display: none;
  }
`;
const CopyRight = styled.div``;

const CompanyLogoContainer = styled.div`
  display: flex;
  margin-left: 30px;
  gap: 40px
`;

const CompanyLogo = styled.img`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto 0;
  height: 50px;
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
`;

const MainFooterContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
const FooterLinksContainer = styled.div``;
const FooterAddressContainer = styled.div``;
const Address = styled.div`
  display: flex;
  justify-content: end;
  flex-direction: column;

  p {
    font-size: 16px;
  }
`;
